export const themes = {
  default: {
    thRoot: 'relative',
    thDatalist:
      'reset-list absolute arrow-up arrow-large arrow-white arrow-bg arrow-bg-blue bg-white border-1 border-blue mt-5 p-2 rounded-small shadow-lg top-full w-full z-6',
  },
  pyr: {
    thRoot: 'fixed',
    thDatalist:
      'reset-list absolute arrow-up arrow-large arrow-white arrow-bg arrow-bg-blue bg-white border-1 border-blue mt-5 p-2 rounded-small shadow-lg top-full w-full z-6',
  },
};
